import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Button from '../components/common/Button';
import { useAuthStore } from '../store/authStore';

export default function NotFound() {
  const { t } = useTranslation('common');
  const { isAuthenticated } = useAuthStore();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <span className="text-9xl font-bold text-primary-600">404</span>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {t('notFound.title')}
        </h1>

        <p className="text-gray-600 mb-8">
          {t('notFound.description')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={isAuthenticated ? '/dashboard' : '/'}>
            <Button variant="primary" className="w-full sm:w-auto">
              <Home className="w-4 h-4 mr-2" />
              {isAuthenticated ? t('nav.dashboard') : t('nav.home')}
            </Button>
          </Link>
          <Button
            variant="outline"
            className="w-full sm:w-auto"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('back')}
          </Button>
        </div>
      </div>
    </div>
  );
}
